var map = {
	"./de/mechaName.png": "amCG",
	"./en/mechaName.png": "qLap",
	"./es/mechaName.png": "sbnx",
	"./fr/mechaName.png": "8730",
	"./ja/mechaName.png": "494/",
	"./ko/mechaName.png": "uSsD",
	"./pt/mechaName.png": "oZ2G",
	"./ru/mechaName.png": "oxqW",
	"./tc/mechaName.png": "03O6",
	"./th/mechaName.png": "aNcf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GQQW";